/** `150,000.00` */
export const formatAmount = (value: number) =>
    value.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** `$1.2 M`, `$350 k`, `$900` para ejes, indicadores y medidores. */
export const compactAmount = (value: number) => {
    const abs = Math.abs(value)
    if (abs >= 1_000_000) return `$${(value / 1_000_000).toLocaleString('es-MX', { maximumFractionDigits: 1 })} M`
    if (abs >= 1_000) return `$${(value / 1_000).toLocaleString('es-MX', { maximumFractionDigits: 1 })} k`
    return `$${Math.round(value).toLocaleString('es-MX')}`
}

export const parseAmount = (value: string) => parseFloat(String(value).replace(/[^0-9.]/g, '')) || 0

/** Deja solo dígitos y un punto decimal, con `maxDecimals` decimales y `maxIntegers` enteros. */
export const sanitizeDecimal = (value: string, maxDecimals = 2, maxIntegers = 12) => {
    const [whole, ...decimals] = value.replace(/[^0-9.]/g, '').split('.')
    const integer = whole.slice(0, maxIntegers)
    return decimals.length ? `${integer}.${decimals.join('').slice(0, maxDecimals)}` : integer
}
